// ABOUTME: Keeps someone who already filled the onboarding form out of it.
// ABOUTME: Hands them back to the app with the query intact, so a shared link survives.

import type { ReactNode } from "react"
import { Navigate, useLocation } from "react-router"
import { useMeContext } from "@/model/user/provider"
import { hasFinishedOnboarding } from "@/model/user/onboarding"
import { CALENDAR_PAGE } from "@shared/constants/navigation"

export const OnboardingGate = ({ children }: { children: ReactNode }) => {
  const { me, currentRole } = useMeContext()
  const { search } = useLocation()

  if (hasFinishedOnboarding(me, currentRole.isCoach)) {
    return (
      <Navigate
        to={{ pathname: CALENDAR_PAGE, search }}
        replace
      />
    )
  }

  return <>{children}</>
}
